import L, { LatLngExpression } from 'leaflet'
import React, { useEffect, useState } from 'react'
import { useMap } from 'react-leaflet'
import { iconUserLocation } from '../utils/MarkerIcons'

interface LocationMarkerProps {
  currentUserPos: LatLngExpression
}

const LocationMarker = (props: LocationMarkerProps): JSX.Element => {
  const map = useMap()
  const currentUserPos = props.currentUserPos

  const [userMarker, setUserMarker] = useState<L.Marker | undefined>()
  useEffect(() => {
    if (map && currentUserPos) {
      console.log(
        'currentUserPos, iconUserLocation',
        currentUserPos,
        iconUserLocation
      )
      map.flyTo(currentUserPos, map.getZoom())
      /* const radius = 150
      const circle = L.circle(currentUserPos, radius)
      circle.addTo(map) */
      if (userMarker) userMarker.removeFrom(map)
      setUserMarker(L.marker(currentUserPos, { icon: iconUserLocation }))
    }
  }, [currentUserPos])

  useEffect(() => {
    if (userMarker && map) {
      userMarker.addTo(map)
    }
  }, [userMarker])

  return <></>
}

/* const icon = L.icon({
  iconSize: [25, 41],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
  iconUrl: 'https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png'
}) */

export { LocationMarker }
